/* ============================================================
   Contacto Tierra — client-side analytics layer
   ------------------------------------------------------------
   Dual-dispatches custom events to:
     1. window.dataLayer  -> GTM (GTM-WZCRZ8X) for GTM tags / Google Ads
     2. window.gtag       -> GA4 (G-H8LGXG5BCQ) directly, so events land
                             in GA4 with NO extra GTM config required.
   Adds scroll-depth, time-on-page and CTA-click tracking on top of
   GA4 Enhanced Measurement (which already covers page_view, 90% scroll,
   outbound clicks, site search, form interactions, file downloads).
   Call window.ctTrack('event_name', {param:value}) from anywhere.
   ============================================================ */
(function () {
  var GA4_ID = 'G-H8LGXG5BCQ';
  window.dataLayer = window.dataLayer || [];

  function track(name, params) {
    params = params || {};
    var payload = {
      page_path: location.pathname,
      page_location: location.href,
      page_title: document.title
    };
    for (var k in params) { if (params[k] !== undefined && params[k] !== null) payload[k] = params[k]; }
    // 1) GTM dataLayer
    try { window.dataLayer.push(Object.assign({ event: name }, payload)); } catch (e) {}
    // 2) GA4 directly (gtag is loaded by the GA4 tag already on the page)
    try {
      if (typeof window.gtag === 'function') {
        var g = Object.assign({}, payload);
        g.send_to = GA4_ID;
        window.gtag('event', name, g);
      }
    } catch (e) {}
  }
  window.ctTrack = track;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* ---------- scroll depth: 25 / 50 / 75 / 100 ----------
       GA4 Enhanced Measurement only fires `scroll` at 90%; this adds the
       granular milestones so we can see where people drop off a page. */
    var fired = {}, ticking = false;
    function checkScroll() {
      ticking = false;
      var d = document.documentElement, b = document.body;
      var max = Math.max(d.scrollHeight, b.scrollHeight) - window.innerHeight;
      if (max <= 0) return;
      var pct = Math.min(100, Math.round(((window.pageYOffset || d.scrollTop) / max) * 100));
      [25, 50, 75, 100].forEach(function (t) {
        if (pct >= t && !fired[t]) { fired[t] = 1; track('scroll_depth', { percent: t }); }
      });
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(checkScroll); ticking = true; }
    }, { passive: true });
    checkScroll();

    /* ---------- active time on page ----------
       Accumulates only while the tab is visible; sent once on the way out.
       Complements GA4's engagement time with an explicit, bucketed metric. */
    var activeMs = 0, last = Date.now(), sent = false;
    function accrue() {
      if (document.visibilityState === 'visible') activeMs += Date.now() - last;
      last = Date.now();
    }
    function bucket(s) {
      if (s < 10) return '0-10s';
      if (s < 30) return '10-30s';
      if (s < 60) return '30-60s';
      if (s < 180) return '1-3m';
      if (s < 600) return '3-10m';
      return '10m+';
    }
    function flushTime() {
      if (sent) return;
      accrue(); sent = true;
      var s = Math.round(activeMs / 1000);
      track('time_on_page', { seconds: s, seconds_bucket: bucket(s) });
    }
    document.addEventListener('visibilitychange', function () {
      accrue();
      if (document.visibilityState === 'hidden') flushTime();
    });
    window.addEventListener('pagehide', flushTime);

    /* ---------- CTA / button clicks ----------
       Explicit: any element with data-cta="id" (optionally data-cta-loc).
       Implicit: any redesign .btn — labelled by its text + nearest section. */
    function sectionOf(el) {
      var explicit = el.closest('[data-section-name]');
      if (explicit) return explicit.getAttribute('data-section-name');
      // nearest semantic <section> with a meaningful class (hero, kits, benefits...)
      var sec = el.closest('section');
      if (sec) {
        var c = (sec.className || '').split(' ').filter(function (x) {
          return x && x !== 'ct' && x.indexOf('color-') !== 0 && x.indexOf('shopify') !== 0 && x.indexOf('section') !== 0;
        })[0];
        if (c) return c;
      }
      // fall back to the Shopify section type baked into the wrapper id
      var ss = el.closest('[id^="shopify-section-"]');
      if (ss && ss.id) {
        var m = ss.id.match(/__([a-z0-9_-]+)$/i);
        return m ? m[1] : ss.id.replace('shopify-section-', '');
      }
      return '';
    }
    document.addEventListener('click', function (e) {
      var cta = e.target.closest('[data-cta]');
      if (cta) {
        track('cta_click', {
          cta_id: cta.getAttribute('data-cta'),
          cta_text: (cta.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80),
          location: cta.getAttribute('data-cta-loc') || sectionOf(cta)
        });
        return;
      }
      var btn = e.target.closest('a.btn, button.btn, .ct .btn');
      if (btn) {
        var txt = (btn.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80);
        if (!txt) return;
        track('cta_click', {
          cta_id: txt,
          cta_text: txt,
          location: sectionOf(btn),
          href: btn.getAttribute('href') || ''
        });
      }
    }, true);
  });
})();
